import type { Sizing } from "@/composables/forms/formTypes";
import type { BuildInfo } from "@/injectionKeys";
import getJsonBlob from "@/utils/getJsonBlob";

export type ExportedSizing = {
  export_info: {
    export_format: number;
    date_created: Date;
    url: Location["href"];
    build_info: BuildInfo;
  };
  payload: Sizing;
};

export default function (
  buildInfo: BuildInfo,
  sizing: Sizing
): {
  snapshot: ExportedSizing;
  filename: string;
  blob: string;
} {
  const exportedSizing = {
    export_info: {
      export_format: 1,
      date_created: new Date(),
      url: window.location.href,
      build_info: buildInfo
    },
    payload: sizing
  };

  return {
    snapshot: exportedSizing,
    filename: `${sizing?.title}.json`,
    blob: getJsonBlob(exportedSizing)
  };
}
